import update from "immutability-helper";
import { mapContentTypes } from "../../methods";
import {
  //Формирование файла отчета
  ANALYTICS_FILE_LOADING_START,
  ANALYTICS_FILE_LOADED_SUCCESSFULLY,
  ANALYTICS_FILE_LOADING_FAILED,
  //Загрузка с сервера доступных фильтров
  FILTER_DATA_LOADING_START,
  FILTER_DATA_LOADED_SUCCESSFULLY,
  FILTER_DATA_LOADING_FAILED,
  //Настройка параметров отчета
  CHANGE_REPORT_TYPE,
  CHANGE_DATE_RANGE,
  CHANGE_CHECKED_USER_TAGS,
  CHANGE_CHECKED_CONTENT_TYPES,
  SWITCH_ALL_USER_TAGS,
  SWITCH_ALL_CONTENT_TYPES,
} from '../actions/analytics';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  filtersLoading: false,
  reportLoading: false,
  type: '',
  dateRange: [null, null], // [startDate, endDate]
  filterdata: {
    userTags: [],
    contentTypes: [],
  },
  checkedUserTagIds: [],
  checkedContentTypes: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Формирование файла отчета
    case ANALYTICS_FILE_LOADING_START:
      return {
        ...state,
        reportLoading: true,
      };
    case ANALYTICS_FILE_LOADED_SUCCESSFULLY:
      return {
        ...state,
        reportLoading: false,
      };
    case ANALYTICS_FILE_LOADING_FAILED:
      return {
        ...state,
        reportLoading: false,
      };
    //Загрузка с сервера доступных фильтров
    case FILTER_DATA_LOADING_START:
      return update(state, {
        filtersLoading: {$set: true},
        filterdata: {
          userTags: {$set: []},
          contentTypes: {$set: []},
        },
        checkedUserTagIds: {$set: []},
        checkedContentTypes: {$set: []},
      });
    case FILTER_DATA_LOADED_SUCCESSFULLY:
      const filterdata = action.payload.filterdata;
      const checkedContentTypes = filterdata && filterdata.contentTypes;
      filterdata.userTags = filterdata.userTags.map(item => {
        //Добавим свойство checked для управления чекбоксом
        //По умолчанию выбраны все чекбоксы
        item.checked = true;
        return item;
      });
      filterdata.contentTypes = filterdata && filterdata.contentTypes 
        && filterdata.contentTypes.map(mapContentTypes);
      //Сформируем массивы из только выбранных значений фильтров. По умолчанию там все элементы
      const checkedUserTagIds = filterdata.userTags.map(item => { return item.id; });
      
      return {
        ...state,
        filtersLoading: false,
        filterdata,
        checkedUserTagIds,
        checkedContentTypes,
      };
    case FILTER_DATA_LOADING_FAILED:
      return {
        ...state,
        filtersLoading: false,
      };
    //НАСТРОЙКА ПАРАМЕТРОВ ОТЧЕТА
    //Тип отчета
    case CHANGE_REPORT_TYPE:
      return {
        ...state,
        type: action.payload.value,
      };
    //Интервал дат
    case CHANGE_DATE_RANGE:
      return update(state, {
        dateRange: {$set: action.payload.dates},
      });
    //Переключение чекбокса типа клиента
    case CHANGE_CHECKED_USER_TAGS:
      const currentUserTag = state.filterdata.userTags[action.payload.index];
      return update(state, {
        filterdata: {
          userTags: {
            [action.payload.index]: {
              checked: {$set: !currentUserTag.checked},
            }
          },
        },
        checkedUserTagIds: {$set: action.payload.newCheckedUserTagIds},
      });
    //Переключение чекбокса типа контента
    case CHANGE_CHECKED_CONTENT_TYPES:
      const currentContentType = state.filterdata.contentTypes[action.payload.index];
      return update(state, {
        filterdata: {
          contentTypes: {
            [action.payload.index]: {
              checked: {$set: !currentContentType.checked},
            }
          },
        },
        checkedContentTypes: {$set: action.payload.newCheckedContentTypes},
      });
    //Выбрать все или очистить все чекбоксы типа клиента
    case SWITCH_ALL_USER_TAGS:
      return update(state, {
        filterdata: {
          userTags: {$set: action.payload.newUserTags},
        },
        checkedUserTagIds: {$set: action.payload.newCheckedUserTagIds},
      });
    //Выбрать все или очистить все чекбоксы типа контента
    case SWITCH_ALL_CONTENT_TYPES:
      return update(state, {
        filterdata: {
          contentTypes: {$set: action.payload.newContentTypes},
        },
        checkedContentTypes: {$set: action.payload.newCheckedContentTypes},
      });
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}